module.exports = __webpack_public_path__ + "static/img/space_ex_heading.ae081d7c.png";